module.exports = __webpack_public_path__ + "img/2024-09-19b_6.48cb44c5.jpg";